
































































import {Vue, Component, VModel, Prop} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import {InvoiceContact, ServiceDTO, ServiceFilter} from "@/components/payroll/business/services/ServiceDTO";
import Page, {EMPTY_PAGE} from "@/dto/taxation/Page";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";
import ServiceCreationSlider from "@/components/payroll/business/services/service/ServiceCreationSlider.vue";
import {v4 as uuidv4} from "uuid";
import ServiceOrchestrator from "@/services/ServiceOrchestrator";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import ServiceItem from "@/components/payroll/business/services/ServiceItem.vue";
import {IProfile} from "@/dto/IProfile";
import {debounce} from "typescript-debounce-decorator";

@Component({
	methods: {uuidv4},
	components: {ServiceItem, ServiceCreationSlider, ServiceView, PortalInput, RightSideBar}
})
export default class ServiceSliderSelector extends Vue {
	@VModel({type: Boolean, default: false})
	private model!: boolean

	@Prop({default: null})
	private contact: any | null = null;

	private search = false
	private createService = false

	private recentServices: Page<ServiceDTO> = EMPTY_PAGE
	private allServices: Page<ServiceDTO> = EMPTY_PAGE

	private filter = new ServiceFilter(
		{
			holderId: this.$wss.getCurrent.id,
			active: true
		}
	)

	private create(service: ServiceDTO) {
		this.recentServices.content = [service, ...this.recentServices.content]
		this.allServices.content = [service, ...this.allServices.content]
		this.selectService(service)
	}

	private selectService(service: ServiceDTO): void {
		this.$emit("selected", service)
		this.$emit("input", false)
	}

	public mount(visible: boolean): void {
		if (visible) {
			if (this.contact) {
				if (this.contact.ref) {
					this.filter.refId = this.contact.ref
				} else {
					this.filter.refId = this.contact.id
				}
			}
			Application.startLoading()
			this.loadRecentServices()
				.then(this.loadAllServices)
				.finally(Application.stopLoading)
		}
	}

	private loadRecentServices() {
		return ServiceOrchestrator.getRecentServices(this.$wss.getCurrent.id).then(
			(res) => {
				this.recentServices = res.data
			},
			err => processError(err, this)
		)
	}

	private loadAllServices() {
		return ServiceOrchestrator.getPageByFilter(this.filter).then(
			(res) => {
				this.allServices = res.data
			},
			err => processError(err, this)
		)
	}

	private findAllServices() {
		Application.startLoading()
			.then(this.loadAllServices)
			.finally(Application.stopLoading)
	}

	@debounce(500)
	public debouncedSearch(): void{
		if (this.filter.name != null && this.filter.name.length > 0) {
			this.search = true
			Application.startLoading()
				.then(this.loadAllServices)
				.finally(Application.stopLoading)
		} else {
			this.search = false
		}
	}

}
